import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Archive/Hello'
import CodeSample from '@/components/Archive/CodeSample'
import AviaSim from '@/components/aviasim/AviaSim'
import Building from '@/components/aviasim/Building'
import Firepad from '@/components/Archive/Firepad'
import Login from '@/components/Archive/Login'
import firebase from '@/firebase'

const requireLogin = (to, from, next) => {
  if (firebase.auth().currentUser) {
    return next()
  } else {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        next()
      } else {
        next('/login')
      }
    })
  }
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'hello',
      component: Hello
    },
    {
      path: '/firepad',
      name: 'firepad',
      component: Firepad
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/aviasim',
      name: 'aviasim',
      component: AviaSim
    },
    {
      path: '/building',
      name: 'building',
      component: Building
    },
    {
      path: '/examples',
      name: 'examples',
      component: CodeSample,
      beforeEnter: requireLogin
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js